import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

var _handledDraftBlocks;

import { Map } from 'immutable';
import { BlockType } from '@uno/common-cms';
// TODO: move this configuration to Block config files
var handledDraftBlocks = (_handledDraftBlocks = {}, _defineProperty(_handledDraftBlocks, BlockType.H1, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.H2, {
  elements: ['h1', 'h2']
}), _defineProperty(_handledDraftBlocks, BlockType.H3, {
  elements: ['h3', 'h4', 'h5', 'h6']
}), _defineProperty(_handledDraftBlocks, BlockType.H4, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.H5, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.H6, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.UL, {
  elements: ['li']
}), _defineProperty(_handledDraftBlocks, BlockType.OL, {
  elements: ['li']
}), _defineProperty(_handledDraftBlocks, BlockType.UNSTYLED, {
  elements: ['div', 'p']
}), _defineProperty(_handledDraftBlocks, BlockType.CODE, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.PARAGRAPH, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.TABLE, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.ATOMIC, {
  elements: []
}), _defineProperty(_handledDraftBlocks, BlockType.BLOCKQUOTE, {
  elements: []
}), _handledDraftBlocks);

/** Revert handledDraftBlocks */
var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
  var blockTypeMap = {};
  Object.entries(blockRenderMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        blockType = _ref2[0],
        description = _ref2[1];

    var elements = description.elements;
    elements.forEach(function (element) {
      if (blockTypeMap[element] === undefined) {
        blockTypeMap[element] = [blockType];
      } else {
        var _blockTypeMap$element;

        blockTypeMap === null || blockTypeMap === void 0 ? void 0 : (_blockTypeMap$element = blockTypeMap[element]) === null || _blockTypeMap$element === void 0 ? void 0 : _blockTypeMap$element.push(blockType);
      }
    });
  });
  return Map(blockTypeMap);
};

var BLOCK_TYPE_MAP = buildBlockTypeMap(handledDraftBlocks);
export var detectBlockType = function detectBlockType(nodeName) {
  return BLOCK_TYPE_MAP.get(nodeName);
};